import React from 'react';
import cn from 'classnames';
import { useBlurredImg } from 'swag-client-common/utils/hooks';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import css from './imba-image.scss';
const ImbaImage = ({
  src,
  alt,
  onClick,
  classNameWrapper,
  className
}) => {
  const calculatedSrc = useBlurredImg({
    highQualitySrc: src
  });
  return /*#__PURE__*/React.createElement(AnimationWrapper, {
    className: cn(css.wrapper, classNameWrapper)
  }, /*#__PURE__*/React.createElement("img", {
    src: calculatedSrc,
    alt: alt,
    onClick: onClick,
    className: cn(css.img, className)
  }));
};
export default ImbaImage;